<template>
  <ButtonDefault
    :button-name="$t('shooting.buttons.player.player')"
    :outlined="true"
    :loading="loading"
    @click="goToPlayer"
  />
</template>

<script>
import ButtonDefault from '@/components/common/atoms/ButtonDefault.vue'
export default {
  name: 'PlayerButton',
  components: {
    ButtonDefault
  },

  data() {
    return {
      loading: false
    }
  },

  props: {
    shootingId: String
  },
  methods: {
    async goToPlayer() {
      this.loading = true

      const { ref } = await this.$store.dispatch('getPlayerInformations', this.shootingId)

      if (ref) {
        this.$router.push({
          path: `/public/player/${ref}`
        })
      }

      this.loading = false
    }
  }
}
</script>
